export default __webpack_public_path__ + "static/media/AneomiOpen4.78e7ed3d.jpg";